import { Navigate } from 'react-router'
import { UserRole } from '../models/User'
import { useAppSelector } from '../store'
import Home from './Home'

const HomeAuth = () => {
  const myRole = useAppSelector((state) => state.user.me.userRole)

  if (myRole === UserRole.MENTEE) return <Navigate to="/mentee" />
  else if (myRole === UserRole.MENTOR) return <Navigate to="/mentor" />
  else return <Home />
}

export default HomeAuth
